<template>
  <main class="box">
    <img v-if="show && preparedImageUrl" class="image" :src="preparedImageUrl" @click="hide" />
  </main>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import isModifierSet from "@/functions/userModifier";
import { ModifierType } from "@/functions/userModifierEnum";
import { useMinioSignedUrl } from "@/functions/useMinioSignedUrl";
import { useGlobalSystemSettings } from "@/functions/useGlobalSystemSettings";

const visible = ref(true);

const { placeholderImage } = useGlobalSystemSettings();
const { url: imageUrl } = useMinioSignedUrl(placeholderImage);

const show = computed((): boolean => {
  return isModifierSet(ModifierType.clippy) && visible.value;
});

function hide() {
  visible.value = !visible.value;
}

const preparedImageUrl = computed(() => imageUrl.value ?? "");
</script>

<style scoped>
.box {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9001;
  width: 200px;
  height: 200px;
  pointer-events: none;
}

.image {
  z-index: 9001;
  float: right;
  max-width: 100%;
  max-height: 100%;
  pointer-events: all;
}
</style>
